import {
  SEARCH_TEACHERS_LOADING,
  SEARCH_TEACHERS_SUCCESS,
  SEARCH_TEACHERS_ERROR,
  SUSPEND_TEACHERS_LOADING,
  SUSPEND_TEACHERS_SUCCESS,
  SUSPEND_TEACHERS_ERROR
} from 'actions/Admin/manageTeacherActions';

const INITIAL_STATE = {
  teachers: null,
  error: null,
  status: null
};

export default function manageTeachersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SEARCH_TEACHERS_LOADING:
      return {
        ...state,
        error: null,
        status: 'LOADING'
      };

    case SEARCH_TEACHERS_SUCCESS:
      return {
        ...state,
        error: null,
        status: 'SUCCESS',
        teachers: action.payload
      };

    case SEARCH_TEACHERS_ERROR:
      return {
        ...state,
        error: { message: action.payload.message },
        status: 'FAIL'
      };

    case SUSPEND_TEACHERS_LOADING:
      return {
        ...state,
        error: null,
        status: 'UPDATING'
      };

    case SUSPEND_TEACHERS_SUCCESS:
      return {
        ...state,
        error: null,
        status: 'SUCCESS',
        teachers: state.teachers.map(t => (t.id === action.payload.id ? action.payload : t))
      };

    case SUSPEND_TEACHERS_ERROR:
      return {
        ...state,
        error: { message: action.payload.message },
        status: 'FAIL'
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/Admin/manageTeachersReducer.js